import React, { useState } from 'react';
import { FormGroup, Input } from 'reactstrap';
import './InputPassword.scss';

const EyeIcon = ({ isVisible }) => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    {isVisible ? (
      <>
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ) : (
      <>
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </>
    )}
  </svg>
);

const InputPassword = ({
  required,
  name,
  id,
  placeholder,
  className,
  value,
  onChange,
  errorsMessage,
  disabled,
  readonly,
  tag,
  mask,
  maskChar,
  autoComplete,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const styles = {
    inputText: {
      borderBottom: '3px solid #24272A',
    },
    toggleButton: {
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      padding: '0 5px',
      color: '#565858',
    }
  };

  const isRequired = required === false ? false : true;

  return (
    <FormGroup className="password-input-wrapper">
      <div style={{ position: 'relative' }}>
        <Input
          required={isRequired}
          type={showPassword ? 'text' : 'password'}
          name={name}
          id={id}
          className={'input-type-text ' + className}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={styles.inputText}
          disabled={disabled}
          readOnly={readonly}
          tag={tag}
          mask={mask}
          maskchar={maskChar}
          autoComplete={autoComplete}
          {...rest}
        />
        <button
          type="button"
          style={styles.toggleButton}
          onClick={() => setShowPassword(!showPassword)}
        >
          <EyeIcon isVisible={showPassword} />
        </button>
      </div>
      <div className="text-red mt-1">{errorsMessage}</div>
    </FormGroup>
  );
};

export default InputPassword;